import logger from './logger';

class SoundManager {
  constructor() {
    const savedEnabled = localStorage.getItem('soundEnabled');
    this.enabled = savedEnabled !== null ? JSON.parse(savedEnabled) : true;
    this.queue = [];
    this.playedLog = [];
    this.isPlaying = false;
    this.currentSound = null;
  }

  play(soundKey) {
    if (!this.enabled || !soundKey) return;

    if (this.currentSound === soundKey || this.queue.includes(soundKey)) return;

    this.playedLog.push({ sound: soundKey });
    if (this.playedLog.length > 10) {
      this.playedLog.shift();
    }

    this.queue.push(soundKey);
    this.processQueue();
  }

  processQueue() {
    if (this.isPlaying || this.queue.length === 0) return;

    const soundKey = this.queue.shift();
    this.currentSound = soundKey;
    const soundPath = `/sounds/${soundKey}.mp3`;

    const audio = new Audio(soundPath);
    audio.currentTime = 0;
    this.isPlaying = true;

    audio.play().catch((err) => {
      logger.warn(`Failed to play sound: ${soundKey}`, err);
      this.isPlaying = false;
      this.currentSound = null;
      this.processQueue();
    });

    audio.onended = () => {
      this.isPlaying = false;
      this.currentSound = null;
      this.processQueue();
    };
  }

  enable() {
    this.enabled = true;
    localStorage.setItem('soundEnabled', true);
  }

  disable() {
    this.enabled = false;
    localStorage.setItem('soundEnabled', false);
  }

  getLog() {
    return this.playedLog;
  }
}

const soundManager = new SoundManager();
export default soundManager;
